import { useMemo } from 'react';
import { ProductType } from '../types';
import { usePresenceManager } from './usePresenceManager';

export const usePresence = (productType: ProductType | null, productId: string | null) => {
  const { getViewers, getViewerCount } = usePresenceManager(productType || undefined);
  
  const viewers = useMemo(() => {
    if (!productType || !productId) return [];
    return getViewers(productType, productId);
  }, [getViewers, productType, productId]);
  
  const viewerCount = useMemo(() => {
    if (!productType || !productId) return 0;
    return getViewerCount(productType, productId);
  }, [getViewerCount, productType, productId]);
  
  const isCurrentUserViewing = useMemo(() => {
    return viewers.some(v => v.isCurrentUser);
  }, [viewers]);
  
  const otherViewers = useMemo(() => {
    return viewers.filter(v => !v.isCurrentUser);
  }, [viewers]);
  
  const otherViewerCount = useMemo(() => {
    return otherViewers.length;
  }, [otherViewers]);

  return { 
    viewers, 
    viewerCount, 
    isCurrentUserViewing,
    otherViewers,
    otherViewerCount
  };
};